import { render, staticRenderFns } from "./config-ope.vue?vue&type=template&id=0c4c6896&scoped=true&"
import script from "./config-ope.vue?vue&type=script&lang=js&"
export * from "./config-ope.vue?vue&type=script&lang=js&"
import style0 from "./config-ope.vue?vue&type=style&index=0&id=0c4c6896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c6896",
  null
  
)

export default component.exports